import { Modal } from "antd";

const PERSIST_SEED_KEYS = [
  "persist:seed:main",
  "persist:seed:client",
  "persist:seed:applicant",
  "persist:link-seed",
  "persist:link-seed-ts",
];

/**
 * Injected from index.js after the store exists (same teardown as sign-out, minus navigation).
 * Avoids importing the store / authActions from this module (circular deps with api/instance).
 */
let sessionExpiredCleanup = null;

export const setSessionExpiredCleanup = (fn) => {
  sessionExpiredCleanup = typeof fn === "function" ? fn : null;
};

/** Once true, never reset until full page navigation — avoids duplicate modals when `afterClose` used to clear a weaker flag while other 401s were still in flight. */
let sessionExpiredFlowStarted = false;

function defaultStorageOnlyCleanup() {
  PERSIST_SEED_KEYS.forEach((k) => localStorage.removeItem(k));
  sessionStorage.clear();
}

export const handleInvalidToken = () => {
  if (sessionExpiredFlowStarted) return;
  sessionExpiredFlowStarted = true;

  Modal.error({
    title: "Session Expired",
    content: "Your session has expired. Please log in again.",
    okText: "I understand, log in again",
    onOk: () => {
      if (sessionExpiredCleanup) {
        try {
          sessionExpiredCleanup();
        } catch (e) {
          console.error("Session expired cleanup failed:", e);
          defaultStorageOnlyCleanup();
        }
      } else {
        defaultStorageOnlyCleanup();
      }
      window.location.replace("/");
    },
    closable: false,
    maskClosable: false,
    okButtonProps: { style: { zIndex: 1000 } },
    centered: true,
  });
};
